import React from 'react';
import classnames from 'classnames/bind';
import _ from 'lodash';

import styles from './ideaReturnToDateStyles';

import Icon from 'buyside/components/presentation/Icon/icon';

import TriangleUpIcon from 'SVGs/triangle_up';
import TriangleDownIcon from 'SVGs/triangle_down';

const cx = classnames.bind(styles);

const IdeaReturnToDate = ({ style, totalReturn, closedAt, showHeader = true }) => {
  let returnFigure = <figure className={styles.pendingText}>Pending...</figure>;
  if (totalReturn || totalReturn === 0) {
    totalReturn = Number(totalReturn);
    const direction = totalReturn >= 0 ? 'positive' : 'negative';
    const returnIcon = direction === 'positive' ? TriangleUpIcon : TriangleDownIcon;
    const returnClass = cx({ returnText: true, [direction]: true });
    const iconClass = cx({ returnIcon: true, [direction]: true });
    let returnToDate = _.round(totalReturn, 1);
    if (returnToDate % 1 === 0) returnToDate = String(returnToDate) + '.0';
    returnFigure = (
      <figure className={returnClass}>
        <Icon style={iconClass} type={returnIcon} />
        {direction === 'positive' ? '+' : ''}
        {returnToDate}%
      </figure>
    );
  }

  return (
    <div className={style}>
      {showHeader && (
        <h5 className={styles.returnToDateHeader}>
          {closedAt ? 'Realized Return:' : 'Return To Date:'}
        </h5>
      )}
      {returnFigure}
    </div>
  );
};

export default IdeaReturnToDate;
